import { Popover, Transition } from '@headlessui/react';
import { Fragment } from 'react';

import { QuestionOutlineIcon } from '~components/icons';
import useLabels from '~hooks/useLabels';

export function InfoPopup() {
  const { msgNewsfeedCustomizeConsent } = useLabels(['msgNewsfeedCustomizeConsent']);
  return (
    <Popover className="relative flex items-center">
      {({ open }) => (
        <>
          <Popover.Button
            className={`
                ${open ? 'bg-darkgray text-white' : 'bg-gray text-darkgray'}
                flex items-center text-base appearance-none w-8 h-8 border-none outline-none cursor-pointer rounded`}
          >
            <QuestionOutlineIcon className="w-6 h-6" />
          </Popover.Button>
          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute right-0 z-20 mb-2 w-screen max-w-xs bottom-full transform pb-4">
              <div className="overflow-hidden rounded-lg shadow-lg bg-white p-4 text-left">
                {msgNewsfeedCustomizeConsent}
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
}
